  document.addEventListener('DOMContentLoaded', function() {

    // open
    document.querySelectorAll('.download-button-block').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var modal = document.querySelector('#popup_download .popup__inner');
        console.log(modal);
        if (!modal) return;
        modal.style.display = 'block';
        requestAnimationFrame(function(){
          modal.style.opacity = '1';
        });
      });
    });
    
    // close
    document.querySelectorAll('#popup_download [data-close-modal]').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function () {
        const modal = document.querySelector('#popup_download .popup__inner');
        if (!modal) return;

        modal.style.opacity = '0';
        setTimeout(function () {
          modal.style.display = 'none';
        }, 300); // wait for fade-out if animated
      });
    });

    const formNewsletter = document.querySelector('#popup_download form[data-newsletter-form]');
    const newFormNewsletter = formNewsletter.cloneNode(true);
    formNewsletter.parentNode.replaceChild(newFormNewsletter, formNewsletter);
    newFormNewsletter.removeAttribute('action');
    !!newFormNewsletter && newFormNewsletter.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      let auxBtnInnerHTML = undefined;
      try {

        const data = document.querySelector('#FormDownloadJson').textContent;

        if(!data) {
          throw new Error('No product data found in FormDownloadJson');
        }

        const tagsInput = newFormNewsletter.querySelector('input[name="tags"]');

        if (tagsInput) {
          tagsInput.remove();
        }

        const submitButton = newFormNewsletter.querySelector('button[type="submit"]');
        const successMessage = newFormNewsletter.querySelector('.newsletter__message--success');
        const errorMessage = newFormNewsletter.querySelector('.newsletter__message--error');

        successMessage.textContent = '';
        errorMessage.textContent = '';
        newFormNewsletter.classList.remove('has-success', 'has-error');

        auxBtnInnerHTML = submitButton.innerHTML;
        submitButton.classList.add('loading');
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.innerHTML = `
          <span class="btn-state-loading">
            <svg height="18" width="18" class="svg-loader">
              <circle r="7" cx="9" cy="9" />
              <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9" />
            </svg>
          </span>`;  

        const productData = JSON.parse(data);
        if (!productData || !productData.url || !productData.productRef) {
          throw new Error('Invalid product data format');
        }

        const emailInput = newFormNewsletter.querySelector('input[name="contact[email]"]');
        const body = {
          email: emailInput.value,
          productRef: productData.productRef
        }

        const options = {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(body)
        };

        const request = await fetch(productData.url, options);
        const response = await request.json();
        console.log('Response:', response);

        if(response.status !== 200)
          throw new Error('Failed to submit the form: ' + response.message);

        newFormNewsletter.querySelector('.newsletter__message--success').textContent = productData.strings.success || response.message || 'Your download is ready. Check your email.';
        newFormNewsletter.classList.remove('has-error');
        newFormNewsletter.classList.add('has-success');

      } catch (error) {
        console.error(error);
        newFormNewsletter.querySelector('.newsletter__message--error').textContent = productData.strings.error || error.message || 'An error occurred while submitting the form.';
        newFormNewsletter.classList.remove('has-success');
        newFormNewsletter.classList.add('has-error');
        return;
      } finally {
        const submitButton = newFormNewsletter.querySelector('button[type="submit"]');
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        submitButton.innerHTML = auxBtnInnerHTML;
        newFormNewsletter.reset();  }
    })
  });
